import { ReactElement } from "react";
import {
  ProgressBarYellow,
  ProgressBarGreen,
  ProgressBarOrange,
  ProgressBarPurple,
  ProgressBarBlue,
  ProgressBarRed,
} from "../progressBar/ProgressBar";
import { OrderStage } from "./helpers";

export const OrderStatusBar = ({
  stage,
}: {
  stage: OrderStage;
}): ReactElement => {
  switch (stage) {
    case "Accepted":
      return <ProgressBarOrange className={"bg-gray-200"} percentage={40} />;
    case "Confirmed":
      return <ProgressBarGreen className={"bg-gray-200"} percentage={60} />;
    case "Dispatched":
      return <ProgressBarPurple className={"bg-gray-200"} percentage={80} />;
    case "Delivered":
      return <ProgressBarBlue className={"bg-gray-200"} percentage={100} />;
    case "Cancelled":
      return <ProgressBarRed className={"bg-gray-200"} percentage={100} />;
    case "Voided":
      return <ProgressBarRed className={"bg-gray-200"} percentage={100} />;
    default:
      return <ProgressBarYellow className={"bg-gray-200"} percentage={20} />;
  }
};
